import * as React from 'react';
import style from './Header.scss';

type Props = {
  address: string
};

const Header: React.FunctionComponent<Props> = (props) => {
  const {address} = props;

  return (
    <>
      <h1 className={style.title}>Уведомления об ограничении</h1>
      <div className={style.address}>{address}</div>
    </>
  );
};

export default React.memo(Header);